import type { SalesChecklistItemDefaultExample } from "@expert/contentful";

import type { ChecklistItemExample } from "./ChecklistItemExampleCarousel";

import { useSalesContext } from "../../../../../../sales-context/SalesContext";
import { useDetectedCuesStore, useProductOfferStore } from "../../../../../../stores";
import { useLanguageStore } from "../../../language-selector/useLanguageStore";
import { getDetectedDeviceExamples } from "../../utils/getDetectedDeviceExamples";
import { CarouselWithDefault } from "./CarouselWithDefault";

interface CoverageCarouselProps {
    defaultExample: SalesChecklistItemDefaultExample;
    staticExamples?: string[];
}

export function CoverageCarousel({ defaultExample, staticExamples }: CoverageCarouselProps) {
    const { sessionId } = useSalesContext();
    const { getPrimaryProducts, getProductInfo } = useProductOfferStore.getState();
    const devices = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));
    const primaryProductSku = getPrimaryProducts(sessionId).at(0)?.productSku;
    const languageState = useLanguageStore();
    const coverageResponses =
        getProductInfo(sessionId, primaryProductSku, languageState.language)?.personalizedCoverage ?? [];
    const detectedExamples = getDetectedDeviceExamples(devices, coverageResponses);

    const staticItems: ChecklistItemExample[] = (staticExamples ?? []).map((text) => ({ text }));
    const examples = [...staticItems, ...detectedExamples];

    return <CarouselWithDefault defaultExample={defaultExample} examples={examples} />;
}
